import * as types from '../actions/types'

const ininitalState = {
  list: [],
  pagination: {},
  showOrderStatus: false,
  orderStatus: {},
}

const OrdersReducer = (state = ininitalState, action) => {
  switch (action.type) {
    case types.UPDATE_ORDERS:
      return {
        ...state,
        list: action.payload,
      }
    case types.UPDATE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case types.UPDATE_ORDER_STATUS:
      return {
        ...state,
        showOrderStatus: true,
        orderStatus: action.payload,
      }
    case types.TOGGLE_ORDER_STATUS_POPUP:
      return {
        ...state,
        showOrderStatus: !state.showOrderStatus,
      }
    default:
      return state
  }
}

export default OrdersReducer
